<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
import StepHeader from '../components/StepHeader.vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))
const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const clickToCancel = () => {
  if (!confirm('Are you sure?')) {
    return
  }

  localStorage.removeItem('tc-claim-issue')
  location.replace('#/order')
}

const clickToContinue = () => {
  if (!selectedOption.value?.key) {
    alert('Please select an option')
    return
  }

  switch (selectedOption.value?.key) {
    case 'lost':
      location.replace('#/claim/lost')
      break
    case 'damage':
      location.replace('#/claim/photos')
      break
    case 'other':
      location.replace('#/claim/other')
      break
  }
}

const chooseOption = option => {
  selectedOption.value = option
  localStorage.setItem('tc-claim-issue', JSON.stringify(option))
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
const items = reactive(readSelectedItems() ?? [])
let orderNumber = ref(data?.orderNumber)
const options = reactive([
  {
    key: 'lost',
    title: 'My package never arrived',
    icon: '<svg fill=none height=27 viewBox="0 0 30 27" width=30 xmlns=http://www.w3.org/2000/svg><g id="Group 4287"><g id=Group><path d="M13.1172 13.082V25.5924" id=Vector stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /></g><g id=Group_2><path d="M25.0078 12.4534V7.44922" id=Vector_2 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /></g><g id=Group_3><path d="M13.1271 1.19922L1.24219 6.8289V7.45442L13.1271 13.0841L25.0119 7.45442V6.8289L13.1271 1.19922Z" id=Vector_3 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 clip-rule=evenodd fill-rule=evenodd /></g><g id=Group_4><path d="M19.3872 9.95362L7.01562 4.09375" id=Vector_4 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /></g><g id=Group_5><path d="M15.6291 24.4046L13.1271 25.5893L1.24219 19.9596V7.44922" id=Vector_5 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /></g><g id=Group_6><path d="M28.761 20.3372C28.761 23.5849 26.1279 26.218 22.8802 26.218C19.6326 26.218 17 23.5855 17 20.3378C17 17.0896 19.6326 14.457 22.8802 14.457C26.1279 14.4564 28.761 17.0896 28.761 20.3372Z" id=Vector_6 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 clip-rule=evenodd fill-rule=evenodd stroke-width=0.940053 /><path d="M22.9453 16.5703V20.6248L24.8659 22.5454" id="Vector 52" stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 stroke-width=0.940053 /></g></g></svg>',
  },
  {
    key: 'damage',
    title: 'Damaged item or quality issue',
    icon: '<svg fill=none height=27 viewBox="0 0 26 27" width=26 xmlns=http://www.w3.org/2000/svg><g id="Group 4287"><path d="M13.1172 13.082V25.5924" id=Vector stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /><path d="M13.1271 1.19922L1.24219 6.8289V7.45442L13.1271 13.0841L25.0119 7.45442V6.8289L13.1271 1.19922Z" id=Vector_2 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 clip-rule=evenodd fill-rule=evenodd /><path d="M19.3872 9.95362L7.01562 4.09375" id=Vector_3 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /><path d="M25 20L22.5 16.5L25 7" id=Vector_4 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /><path d="M25 19.9596L13.1271 25.5893L1.24219 19.9596V7.44922" id=Vector_5 stroke=#2E1319 stroke-linejoin=round stroke-miterlimit=2 /></g></svg>',
  },
  {
    key: 'other',
    title: 'Get help with something else',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M14.1172 15.082V27.5924" stroke="#2E1319" stroke-miterlimit="2" stroke-linejoin="round"/><path d="M26.0078 14.4534V9.44922" stroke="#2E1319" stroke-miterlimit="2" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.1271 3.19922L2.24219 8.8289V9.45442L14.1271 15.0841L26.0119 9.45442V8.8289L14.1271 3.19922Z" stroke="#2E1319" stroke-miterlimit="2" stroke-linejoin="round"/><path d="M20.3872 11.9536L8.01562 6.09375" stroke="#2E1319" stroke-miterlimit="2" stroke-linejoin="round"/><path d="M19.5 25.5L14.1271 27.5893L2.24219 21.9596V9.44922" stroke="#2E1319" stroke-miterlimit="2" stroke-linejoin="round"/><path d="M22 19.6225C22.9486 18.7925 24.4865 18.7925 25.4351 19.6225C26.3837 20.4525 26.3837 21.7982 25.4351 22.6282C25.27 22.7727 25.087 22.892 24.8924 22.9862C24.2887 23.2784 23.7175 23.7945 23.7175 24.4652V25.0724M23.7174 27.5014H23.7234V27.5075H23.7174V27.5014Z" stroke="#2E1319" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  },
])
let selectedOption = ref(null)
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
    return
  }

  selectedOption.value = JSON.parse(localStorage.getItem('tc-claim-issue'))
})
//endregion
</script>

<template>

<!--
<figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>
-->

  <div class="px-[20px] my-[30px] lg:px-[40px]">

    <h1 class="font-bold text-tc-subtitle font-minionpro text-tc-black mx-auto mb-[30px]"
        v-text="`How can we help you with your order?`"
    ></h1>

    <step-header :data="data" :items="items"/>

    <main class="max-w-[420px] mx-auto">

      <ul class="grid grid-cols-2 gap-[20px] mb-[30px]">
        <li v-for="option in options" :key="option.key" class="bg-tc-off-white px-[15px] py-[20px] border cursor-pointer flex flex-col gap-4 justify-start"
            @click="chooseOption(option)"
            :class="{ 'border-black': selectedOption?.key === option.key, 'border-tc-off-white': selectedOption?.key !== option.key }">
          <div class="w-10 h-10" v-html="option.icon"></div>
          <h3 class="mt-[12px] text-tc-maroon text-tc-xl tracking-wider font-avenir font-normal max-w-[90%]" v-text="option.title"></h3>
        </li>
      </ul>

      <div class="my-[30px] flex flex-row justify-between">
        <button type="button"
            @click="clickToCancel"
            class="text-tc-xl text-black tracking-wider font-normal font-avenir py-2.5 px-8 border-b border-tc-creme"
        >Cancel
        </button>
        <button type="submit"
            @click="clickToContinue"
            class="text-tc-xl text-black tracking-wider font-normal font-avenir py-2.5 px-8 border border-tc-creme"
        >Next
        </button>
      </div>

    </main>

  </div>

</template>

<style scoped>
</style>